import Repository from '@/libs/axios'

const agreementBuilderResource = '/admin/merchant/agreement/template'

export default {
  getAgreementTemplate() {
    return Repository.get(`${agreementBuilderResource}`)
  },
  saveAgreementTemplate(payload) {
    return Repository.put(`${agreementBuilderResource}`, payload)
  },
  getMerchantAgreement(merchantId) {
    return Repository.get(`/admin/merchant/${merchantId}/agreement`)
  },
}
